import { COMPARISON_SLUGS } from "@listou/shared/constants";
import { createFileRoute, Link } from "@tanstack/react-router";

import { SiteFooter, SiteHeader } from "../components/site-header";
import { COMPARISONS } from "../lib/comparisons";
import { seo } from "../lib/head";

export const Route = createFileRoute("/comparatif/")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Comparatifs : Listou face aux autres listes de cadeaux · Listou",
      description:
        "Listou comparé aux autres listes de naissance et de cadeaux en ligne : prix, surprise, gestion à deux, boutiques acceptées. Des faits vérifiés et datés.",
    }),
  component: ComparisonHub,
});

function ComparisonHub() {
  return (
    <div className="min-h-dvh">
      <SiteHeader signedIn={false} />
      <main className="mx-auto grid max-w-4xl gap-10 px-4 pt-10 pb-20 sm:px-6">
        <header className="grid gap-4">
          <h1 className="text-4xl font-medium sm:text-5xl">Listou et les autres</h1>
          <p className="max-w-[56ch] text-xl text-ink/80">
            Vous hésitez entre plusieurs sites de liste de cadeaux ? Voici ce qui les distingue,
            point par point, avec les sources de chaque information.
          </p>
        </header>
        <ul className="grid gap-4">
          {COMPARISON_SLUGS.map((slug) => (
            <li key={slug}>
              <Link
                to="/comparatif/$slug"
                params={{ slug }}
                className="panel grid gap-2 p-6 transition hover:-translate-y-0.5"
              >
                <span className="text-2xl font-semibold">Listou ou {COMPARISONS[slug].name}</span>
                <span className="text-muted">{COMPARISONS[slug].seoDescription}</span>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <SiteFooter />
    </div>
  );
}
